export default __webpack_public_path__ + "images/4282b89c7f7f7b7278a1606d983a4d60-PH_Top_Mobile.jpg";